var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBelarus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.739 237.449L77.9131 186.966L105.739 137.275L133.565 186.966L105.739 237.449Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0867 237.449L22.2607 186.966L50.0867 137.275L77.9127 186.966L50.0867 237.449Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.739 374.725L77.9131 324.242L105.739 274.551L133.565 324.242L105.739 374.725Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0867 374.725L22.2607 324.242L50.0867 274.551L77.9127 324.242L50.0867 374.725Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.565 49.692L125.687 35.624C111.557 43.996 98.3038 53.689 86.0928 64.533L105.739 100.174L133.565 49.692Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.739 411.826L85.8848 447.282C98.0848 458.14 111.329 467.848 125.453 476.237L133.566 461.518L105.739 411.826Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.826 322.783V491.646C186.595 504.743 220.448 512 256 512C366.071 512 459.906 442.528 496.077 345.043L155.826 322.783Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.077 345.043C506.368 317.31 512 287.314 512 256C512 114.616 397.384 0 256 0C220.451 0 186.595 7.253 155.826 20.348V345.044H496.077V345.043Z",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7096"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBelarus);
export default __webpack_public_path__ + "static/media/belarus.9b91b295fe42f5c4297f2d45bc142680.svg";
export { ForwardRef as ReactComponent };